import React from 'react'
import TestTakingSkill from './TestTakingSkill'

export default function TestTakingSkills ({testTakingData}) {
  const skills = [
    {name: 'Time Management', key: 'timeManagement'},
    {name: 'Pacing', key: 'pacing'},
    {name: 'Stamina', key: 'stamina'},
    {name: 'No Blanks', key: 'noBlanks'},
    {name: 'Process of Elimination', key: 'processOfElimination'},
    {name: 'Precision', key: 'precision'},
    {name: 'Motivation', key: 'motivation'},
  ]
  return (
    <section className='Skills'>
      {
        skills.map(skill => 
          <TestTakingSkill 
            name={skill.name}
            stars={testTakingData[skill.key].stars}
            key={`${skill.key}overview`}
          />
        )
      }
    </section>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/Overview/TestTakingSkills.js